import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles(theme => ({
  paper: {
    padding: '52px 42px 47px',
  },
  dialogContent: {
    padding: '0 !important',
  },
  balance: {
    margin: '29px auto 48px',
    maxWidth: 455,
    textAlign: 'center',
  },
  error: {
    color: '#f44336',
  },
  button: {
    borderRadius: 13,
    boxShadow: '0 3px 13px #c6e5ff',
    padding: '12px 16px',
    [theme.breakpoints.up('md')]: {
      minWidth: 544,
    },
    [theme.breakpoints.between('sm', 'md')]: {
      minWidth: 455,
    },
  },
  buttonLabel: {
    fontSize: 19,
    fontWeight: 600,
    textTransform: 'none',
  },
}));
